/* eslint-disable react/prop-types */

import * as React from 'react';
import styled from 'styled-components';

import { withRouter } from 'next/router';
import { Link } from '../../routes';

import withI18n from '../../utils/withI18n';

const RowWrapper = styled.div`
  .ReactVirtualized__Table__row:hover {
    background: ${({ theme }) => theme.tableRowHoverBg};
  }
`;

const getMarketPair = ([newSymbol, ticker]) => {
  const baseAsset = ticker.ba;
  const quoteAsset = newSymbol.split(baseAsset)[1];
  return `${baseAsset}_${quoteAsset}`;
};

const getTradePageLinkHref = ([newSymbol, ticker], { asPath }, locale) => {
  const tradePath = asPath.includes('/pro/') ? '/trade/pro/' : '/trade/';
  const newPair = getMarketPair([newSymbol, ticker]);
  return `/${locale}${tradePath}${newPair}`;
};

export default withI18n(
  withRouter(
    ({
      className,
      columns,
      index,
      key,
      onRowClick,
      onRowDoubleClick,
      onRowMouseOut,
      onRowMouseOver,
      onRowRightClick,
      rowData,
      style,
      router,
      scroll,
      locale,
      id,
    }) => {
      const a11yProps = {};

      if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
        a11yProps['aria-label'] = 'row';
        a11yProps.tabIndex = 0;

        if (onRowClick) {
          a11yProps.onClick = event => onRowClick({ event, index, rowData });
        }
        if (onRowDoubleClick) {
          a11yProps.onDoubleClick = event => onRowDoubleClick({ event, index, rowData });
        }
        if (onRowMouseOut) {
          a11yProps.onMouseOut = event => onRowMouseOut({ event, index, rowData });
        }
        if (onRowMouseOver) {
          a11yProps.onMouseOver = event => onRowMouseOver({ event, index, rowData });
        }
        if (onRowRightClick) {
          a11yProps.onContextMenu = event => onRowRightClick({ event, index, rowData });
        }
      }

      const scrollToTop = typeof scroll === 'boolean' ? scroll : true;

      return (
        <RowWrapper role="row" key={key}>
          <Link
            route={getTradePageLinkHref(rowData, router, locale)}
            prefetch={true}
            scroll={scrollToTop}
            key={key}
          >
            <a id={id} {...a11yProps} className={className} style={style}>
              {columns}
            </a>
          </Link>
        </RowWrapper>
      );
    }
  )
);
